import { Tooltip } from '@lifebit-ai/lds'
import React from 'react'

import type { ResultLabel } from 'services/results/types'
import { LabelTag } from 'ui/labelTag/labelTag.styles'

import * as styles from './LabelsColumnContent.styles'

interface LabelsColumnContentProps {
  labels?: ResultLabel[]
}

export const LabelsColumnContent = ({ labels }: LabelsColumnContentProps): JSX.Element => {
  if (!labels?.length) return <span>-</span>

  const initialLabels = labels.slice(0, 2)
  const remainingLabels = labels.slice(2)

  return (
    <styles.LabelsContainer>
      {initialLabels.map((label: ResultLabel) => (
        <LabelTag key={label._id}>{label.name}</LabelTag>
      ))}

      {remainingLabels.length > 0 && (
        <Tooltip
          title={remainingLabels.map((label: ResultLabel, index: number) => (
            <span key={label._id}>
              {label.name}
              {index < remainingLabels.length - 1 && <br />}
            </span>
          ))}
        >
          <styles.RemainingLabelsCount>{`+${remainingLabels.length}`}</styles.RemainingLabelsCount>
        </Tooltip>
      )}
    </styles.LabelsContainer>
  )
}
